import {fetchHelper, simulateDelay} from '../utils/requestUtils';

export const getEntryMany = async (sourceKey, page, pageSize, sortColumn, sortDirection) => {
    await simulateDelay();
    let urlBuilder = `/entries/getMany?`
    if (sourceKey) urlBuilder += `&sourceKey=${encodeURIComponent(sourceKey)}`
    if (page) urlBuilder += `&page=${encodeURIComponent(page)}`
    if (pageSize) urlBuilder += `&pageSize=${encodeURIComponent(pageSize)}`
    if (sortColumn) urlBuilder += `&sortColumn=${encodeURIComponent(sortColumn)}`
    if (sortDirection) urlBuilder += `&sortDirection=${encodeURIComponent(sortDirection)}`
    const response = await fetchHelper({
        method: "GET",
        url: urlBuilder,
    })
    return response
}

export const submitCreateEntry = async (input) => {
    await simulateDelay();
    const response = await fetchHelper({
        method: "POST",
        url: "/entries/create",
        reqBody: {
            entryDate: input.entry_date,
            comments: input.comments,
            sourceKey: input.source_key,
            amount: input.amount,
        }
    })
    return response;
}

export const submitUpdateEntry = async (input) => {
    await simulateDelay();
    const response = await fetchHelper({
        method: "PUT",
        url: "/entries/update",
        reqBody: {
            _id: input._id,
            entryDate: input.entry_date,
            comments: input.comments,
            amount: input.amount,
        }
    })
    return response;
}

export const submitDeleteEntry = async (entryId) => {
    await simulateDelay();
    const response = await fetchHelper({
        method: "DELETE",
        url: "/entries/delete",
        reqBody: {
            _id: entryId,
        }
    })
    return response
}
